import ts from 'typescript';
import { NodeCompiler } from '../NodeCompiler';
export class TypeAliasDeclarationCompiler extends NodeCompiler {
    constructor() {
        super(...arguments);
        this.kind = ts.SyntaxKind.TypeAliasDeclaration;
    }
    visitNode(_sb, _node, _optionsIn) {
    }
}

//# sourceMappingURL=TypeAliasDeclarationCompiler.js.map
